export default __webpack_public_path__ + "static/media/point.bdcf3183.svg";